import MarketplaceIcon from '@/assets/icons/marketplace.png';
import { Card } from '@/components/atoms';
import { PageHeader } from '@/components/organisms';
import { Layout } from '@/components/templates';

const SosMessagesView = ({ children }) => {
    return (
        <>
            <PageHeader icon={{ src: MarketplaceIcon }} title="SOS Messages Statistics" />
            <Layout>
                <Card>{children.userResults}</Card>
            </Layout>
        </>
    );
};

export { SosMessagesView };
